import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpResponse, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class ApiConfigInterceptor implements HttpInterceptor {
    private getStoredHeaderValue(key: string): string | null {
        const value = sessionStorage.getItem(key);
        if (!value || value === 'null' || value === 'undefined') {
            return null;
        }

        return value;
    }

    private getHeaderValue(key: 'company-id' | 'location-id'): string | null {
        return this.getStoredHeaderValue(
            key === 'company-id' ? 'companyId' : 'locationId'
        );
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        if ((request.url.includes('api/frontend/v1') || request.url.includes('api/verify/v1') || request.url.includes('api/google/v1')) && !request.headers.has('no-override') && !request.headers.has('no-overrid')) {
            if(!request.headers.keys().includes('company-id')){
                const companyId = this.getHeaderValue('company-id');
                if (companyId) {
                    request = request.clone({
                        headers: request.headers.set('company-id', companyId)
                    });
                }
            }

            if(!request.headers.keys().includes('location-id')){
                const locationId = this.getHeaderValue('location-id');
                if (locationId) {
                    request = request.clone({
                        headers: request.headers.set('location-id', locationId)
                    });
                }
            }
    
        }

        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                return event;
            }),
            catchError((error: HttpErrorResponse) => throwError(error)));
    }
}
